// src/components/inventory/AdjustAlertNotice.js
//
// #363, Session 79.22b.6.6 -- the line above Confirm on BOTH adjust sheets that
// says, before the person saves, whether their managers will be notified (gate
// D3, drawn in Screen 1 of docs/gates/Stede_AdjustmentThreshold_Gate_363.html).
// Green and plain when nobody will be; plain grey, never red, when they will
// (callout B) - telling a manager is normal, and a warning would teach people
// not to write off damaged stock.
//
// It PREDICTS from what it reads when the sheet opens; the save DECIDES from a
// fresh read (D18) and the done screen reports what the save did (D17).
// The dollar figure and the limits show only for people who may see stock cost
// (D12, canSeeInventoryCost), and the words come from stockMovements.js, so the
// sheet, the done line and the alert can never disagree.
//
// Module level, not nested - locked rule 2.

import { useEffect, useState } from 'react';
import { adjustAlertDecision, adjustNoticeLines, readAdjustAlertInputs } from '../../lib/stockMovements';

const TONES = {
  quiet: { background: '#E1F5EE', border: '1px solid #B4E0CF', head: '#085041', detail: '#085041' },
  told: { background: '#F4F4F2', border: '1px solid #DCDCD8', head: '#0F0F0F', detail: '#3A3A3A' },
  check: { background: 'white', border: '1px dashed #D0D0D0', head: '#6A6A6A', detail: '#6A6A6A' },
};

export default function AdjustAlertNotice({ itemId, branchId, branchName, onHand, counted, reason, canSeeCost }) {
  const [inputs, setInputs] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setInputs(null);
    readAdjustAlertInputs(itemId, branchId)
      .then(r => { if (!cancelled) setInputs(r); })
      .catch(() => { if (!cancelled) setInputs({ settings: null, unitCost: null }); });
    return () => { cancelled = true; };
  }, [itemId, branchId]);

  // A count that cannot be saved has no answer yet; the save says why.
  const n = Number(counted);
  if (counted === '' || counted === null || counted === undefined || !Number.isInteger(n) || n < 0) return null;

  let tone, head, detail;
  if (!inputs) {
    tone = 'check';
    head = 'Checking who will be notified…';
    detail = null;
  } else {
    const decision = adjustAlertDecision({ reason, onHandBefore: onHand, counted: n, unitCost: inputs.unitCost, settings: inputs.settings });
    ({ tone, head, detail } = adjustNoticeLines(decision, { canSeeCost, branchName, settings: inputs.settings }));
  }
  const t = TONES[tone];
  return (
    <div role="status" aria-live="polite" data-testid="adjust-alert-notice" data-tone={tone}
      style={{ background: t.background, border: t.border, borderRadius: 8, padding: '10px 12px', marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: tone === 'check' ? 600 : 700, color: t.head, lineHeight: 1.35 }}>{head}</div>
      {detail && <div style={{ fontSize: 11.5, color: t.detail, marginTop: 2, lineHeight: 1.45 }}>{detail}</div>}
    </div>
  );
}
